export default __webpack_public_path__ + "static/media/emily.2150c628.jpeg";